'use strict';

var Json_decode = require("@glennsl/bs-json/lib/js/src/Json_decode.js");
var Url$PvpcontrollerWeb = require("./Url.js");
var Request$PvpcontrollerWeb = require("./Request.js");
var UpdateResponse$PvpcontrollerWeb = require("./UpdateResponse.js");
var EditModeService$PvpcontrollerWeb = require("./EditModeService.js");
var ProjectileModel$PvpcontrollerWeb = require("../models/ProjectileModel.js");

function projectilesResponse(json) {
  return {
          status: Json_decode.field("status", Json_decode.$$int, json),
          projectiles: Json_decode.field("projectiles", (function (param) {
                  return Json_decode.array(ProjectileModel$PvpcontrollerWeb.Decode.projectile, param);
                }), json)
        };
}

function projectileResponse(json) {
  return {
          status: Json_decode.field("status", Json_decode.$$int, json),
          projectile: Json_decode.field("projectile", ProjectileModel$PvpcontrollerWeb.Decode.projectile, json)
        };
}

function projectileSearchResponse(json) {
  return {
          status: Json_decode.field("status", Json_decode.$$int, json),
          projectiles: Json_decode.field("projectiles", (function (param) {
                  return Json_decode.array(ProjectileModel$PvpcontrollerWeb.Decode.projectile, param);
                }), json)
        };
}

function projectileChangelogResponse(json) {
  return {
          status: Json_decode.field("status", Json_decode.$$int, json),
          changes: Json_decode.field("changes", (function (param) {
                  return Json_decode.array(EditModeService$PvpcontrollerWeb.Decode.change, param);
                }), json),
          totalSize: Json_decode.field("totalSize", Json_decode.$$int, json)
        };
}

function getProjectile(id, cb) {
  return Request$PvpcontrollerWeb.getWithDecoder(Url$PvpcontrollerWeb.pvpcapi + "/api/projectile/" + String(id), (function (response) {
                return {
                        TAG: /* Ok */0,
                        _0: projectileResponse(response).projectile
                      };
              }), cb);
}

function getProjectiles(offset, amt, cb) {
  return Request$PvpcontrollerWeb.getWithDecoder(Url$PvpcontrollerWeb.pvpcapi + "/api/projectiles/all/" + String(offset) + "/" + String(amt), (function (response) {
                return {
                        TAG: /* Ok */0,
                        _0: projectilesResponse(response).projectiles
                      };
              }), cb);
}

function getProjectileChangelog(id, skip, limit, cb) {
  var skip$1 = String(skip);
  var limit$1 = String(limit);
  return Request$PvpcontrollerWeb.getWithDecoder(Url$PvpcontrollerWeb.pvpcapi + "/api/projectile/changelog/" + id.toString() + "/" + skip$1 + "/" + limit$1, (function (response) {
                var match = projectileChangelogResponse(response);
                return {
                        TAG: /* Ok */0,
                        _0: {
                          changes: match.changes,
                          totalSize: match.totalSize
                        }
                      };
              }), cb);
}

function searchProjectiles(terms, cb) {
  var terms$1 = encodeURIComponent(terms);
  return Request$PvpcontrollerWeb.getWithDecoder(Url$PvpcontrollerWeb.pvpcapi + "/api/projectiles/search/" + terms$1, (function (response) {
                return {
                        TAG: /* Ok */0,
                        _0: projectileSearchResponse(response).projectiles
                      };
              }), cb);
}

function updateProjectileDamage(param, param$1, cb) {
  var match = param.VAL;
  var sessionId = String(match.id);
  var netId = String(param$1.netId);
  var damageRatio = String(param$1.damageRatio);
  return Request$PvpcontrollerWeb.postWithDecoder(Url$PvpcontrollerWeb.pvpcapi + "/api/projectile/update/damage", "damage=" + damageRatio + "&netID=" + netId + "&sessionId=" + sessionId + "&token=" + match.token, UpdateResponse$PvpcontrollerWeb.Decode.updateResponse, cb);
}

function updateProjectileVelocity(param, param$1, cb) {
  var match = param.VAL;
  var sessionId = String(match.id);
  var netId = String(param$1.netId);
  var velocityRatio = String(param$1.velocityRatio);
  return Request$PvpcontrollerWeb.postWithDecoder(Url$PvpcontrollerWeb.pvpcapi + "/api/projectile/update/velocity", "velocity=" + velocityRatio + "&netID=" + netId + "&sessionId=" + sessionId + "&token=" + match.token, UpdateResponse$PvpcontrollerWeb.Decode.updateResponse, cb);
}

function updateProjectileBanned(param, param$1, cb) {
  var match = param.VAL;
  var sessionId = String(match.id);
  var netId = String(param$1.netId);
  var banned = param$1.banned ? "true" : "false";
  return Request$PvpcontrollerWeb.postWithDecoder(Url$PvpcontrollerWeb.pvpcapi + "/api/projectile/update/banned", "banned=" + banned + "&netID=" + netId + "&sessionId=" + sessionId + "&token=" + match.token, UpdateResponse$PvpcontrollerWeb.Decode.updateResponse, cb);
}

exports.getProjectile = getProjectile;
exports.getProjectiles = getProjectiles;
exports.getProjectileChangelog = getProjectileChangelog;
exports.searchProjectiles = searchProjectiles;
exports.updateProjectileDamage = updateProjectileDamage;
exports.updateProjectileVelocity = updateProjectileVelocity;
exports.updateProjectileBanned = updateProjectileBanned;
/* Url-PvpcontrollerWeb Not a pure module */
